import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { PaymentIdentifier } from './payment-identifier';
import { PaymentIdentifierSetup } from './payment-identifier-setup';
import { PaymentProvider } from './payment-provider';
import { Vendor } from './vendor';

export class PaymentCustomer extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static PaymentCustomerProperties: (
    | {
        property: keyof PaymentCustomer;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof PaymentCustomer;
        type: 'alias';
      }
    | {
        property: keyof PaymentCustomer;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'ContactId', type: 'column', dataType: 'number' },
    { property: 'PaymentProviderId', type: 'column', dataType: 'number' },
    { property: 'CustomerId', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Vendor', model: 'Vendor', type: 'association' },
    {
      property: 'PaymentProvider',
      model: 'PaymentProvider',
      type: 'association'
    },
    {
      property: 'PaymentIdentifiers',
      model: 'PaymentIdentifier',
      type: 'association'
    },
    {
      property: 'PaymentIdentifierSetups',
      model: 'PaymentIdentifierSetup',
      type: 'association'
    }
  ];

  static {
    PaymentCustomer.PaymentCustomerProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        PaymentCustomer.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        PaymentCustomer.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        PaymentCustomer.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(PaymentCustomerObject: Partial<PaymentCustomer>) {
    super();

    PaymentCustomer.PaymentCustomerProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = PaymentCustomerObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  VendorId?: number;
  ContactId?: number;
  PaymentProviderId?: number;
  CustomerId?: string;
  createdAt?: Date;
  updatedAt?: Date;

  Vendor?: Vendor;
  PaymentProvider?: PaymentProvider;
  PaymentIdentifiers?: PaymentIdentifier[];
  PaymentIdentifierSetups?: PaymentIdentifierSetup[];
}
